"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGridV4FuturesTradeInfo = exports.useGridV4FuturesTradeInfo = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const GridV4FuturesProcessor_1 = require("../GridV4FuturesProcessor");
const rxjs_1 = require("rxjs");
const apis_1 = require("../apis");
const trade_utils_lib_1 = require("trade_utils_lib");
const react_1 = require("react");
const lodash_1 = require("lodash");
const parseLiquidationForMode_1 = require("../Tools/parseLiquidationForMode");
function checkTradeInfoRequestFunc(params, extra) {
    var _a, _b, _c;
    const { base, quote, top, bottom, row, grid_type, open_price, trend, leverage, quote_investment, extra_margin, extra_margin_amount, is_copy_bot, } = params;
    if (!base || !quote || !top || !bottom || !row || !grid_type || !open_price || !trend || !leverage) {
        (_a = extra === null || extra === void 0 ? void 0 : extra.onError) === null || _a === void 0 ? void 0 : _a.call(extra);
        throw { code: -1, message: "params not valid" };
    }
    if (Number(bottom) >= Number(top) || Number(row) < 2) {
        (_b = extra === null || extra === void 0 ? void 0 : extra.onError) === null || _b === void 0 ? void 0 : _b.call(extra);
        throw { code: -1, message: "params not valid" };
    }
    if (Number(row) > GridV4FuturesProcessor_1.GridV4FuturesMaxGrids) {
        (_c = extra === null || extra === void 0 ? void 0 : extra.onError) === null || _c === void 0 ? void 0 : _c.call(extra);
        throw { code: -1, message: "params not valid" };
    }
    return {
        base,
        quote,
        top,
        bottom,
        row,
        grid_type,
        open_price,
        trend,
        leverage,
        quote_investment: quote_investment || "0",
        extra_margin,
        extra_margin_amount,
        is_copy_bot,
    };
}
function queryTradeInfoAPI(params, invest_precision, price_precision, transToModel = TradeAPILib_1.GridFuturesMode.normal) {
    const { base, quote, top, bottom, row, grid_type, open_price, trend, leverage, quote_investment, extra_margin, extra_margin_amount, is_copy_bot, } = params;
    return (0, apis_1.tradeInfoAPI)({
        base,
        quote,
        top,
        bottom,
        row,
        grid_type,
        open_price,
        trend,
        leverage,
        quote_investment: quote_investment || "0",
        extra_margin,
        extra_margin_amount,
        is_copy_bot,
    }).pipe((0, rxjs_1.map)((resp) => {
        let tradeInvest = "";
        let marginInvest = "";
        if (Number(quote_investment)) {
            if (!extra_margin) {
                tradeInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(quote_investment, invest_precision);
                marginInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(extra_margin_amount, invest_precision);
            }
            else {
                const esMargin = new trade_utils_lib_1.SafeDecimal(resp.estimate_extra_margin);
                tradeInvest = esMargin.eq(0)
                    ? quote_investment || "0"
                    : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(resp.estimate_position_occupy_margin)
                        .add(new trade_utils_lib_1.SafeDecimal(resp.estimate_fee))
                        .add(new trade_utils_lib_1.SafeDecimal(resp.estimate_order_occupy_margin)), invest_precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                marginInvest = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(quote_investment).sub(new trade_utils_lib_1.SafeDecimal(tradeInvest)), 0), invest_precision);
            }
        }
        const { up: liquiUpDisplay, down: liquiDownDisplay } = (0, parseLiquidationForMode_1.parseLiquidationDisplayForMode)({
            mode: transToModel,
            liquidationUp: resp.estimate_liquidation_price_up,
            liquidationDown: resp.estimate_liquidation_price_down,
            precision: new trade_utils_lib_1.SafeDecimal(price_precision).toNumber(),
        });
        let liquiDown = undefined;
        let liquiUp = undefined;
        if (new trade_utils_lib_1.SafeDecimal(resp.estimate_liquidation_price_down).isZero() === false) {
            if (transToModel === TradeAPILib_1.GridFuturesMode.coin_m) {
                liquiDown = resp.estimate_liquidation_price_down;
            }
            else {
                liquiDown = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(resp.estimate_liquidation_price_down, price_precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
            }
        }
        if (new trade_utils_lib_1.SafeDecimal(resp.estimate_liquidation_price_up).isZero() === false) {
            if (transToModel === TradeAPILib_1.GridFuturesMode.coin_m) {
                liquiUp = resp.estimate_liquidation_price_up;
            }
            else {
                liquiUp = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(resp.estimate_liquidation_price_up, price_precision, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
            }
        }
        return Object.assign(Object.assign({}, resp), { estimateTradeInvest: tradeInvest, estimateMarginInvest: marginInvest, estimate_liquidation_price_down: liquiDown, estimate_liquidation_price_up: liquiUp, estimate_liquidation_price_down_display: liquiDownDisplay, estimate_liquidation_price_up_display: liquiUpDisplay });
    }));
}
function getTradeInfoAPI(params) {
    return (0, rxjs_1.of)(params).pipe((0, rxjs_1.map)((reqOp) => {
        return checkTradeInfoRequestFunc(reqOp);
    }), (0, rxjs_1.mergeMap)((req) => {
        return queryTradeInfoAPI(req, params.invest_precision, params.price_precision, params.transToMode);
    }));
}
const useTradeInfo = (request) => {
    const [tradeInfo, setTradeInfo] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const { base, quote, top, bottom, row, grid_type, open_price, trend, leverage, quote_investment, user_investment, extra_margin, extra_margin_amount, is_copy_bot, transToMode, } = request;
    const requestRef = (0, react_1.useRef)(request);
    requestRef.current = request;
    const debounceFn = (0, react_1.useRef)((0, lodash_1.debounce)(() => {
        const sub = (0, rxjs_1.of)(requestRef.current)
            .pipe((0, rxjs_1.map)((reqOp) => {
            return checkTradeInfoRequestFunc(reqOp, { onError: () => setTradeInfo(undefined) });
        }), (0, rxjs_1.mergeMap)((req) => {
            setLoading(true);
            return queryTradeInfoAPI(req, requestRef.current.invest_precision, requestRef.current.price_precision, transToMode).pipe((0, rxjs_1.catchError)((error) => {
                let newReq = Object.assign(Object.assign({}, req), { quote_investment: "0" });
                return queryTradeInfoAPI(newReq, requestRef.current.invest_precision, requestRef.current.price_precision, transToMode);
            }));
        }))
            .subscribe({
            next: (data) => {
                setTradeInfo(data);
                setLoading(false);
            },
            error: (error) => {
                setLoading(false);
                // console.log(`useFuturesTradeInfo: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 500));
    // 在初始化的时候，open_price 有可能为空, quote_investment有可能是被swap转化过的值(跟着quote/USDT的价格实时转动)
    // 造成 tradeInfo 无法初始化， 所以这里 特意使用一个 hooks 确保初始化成功
    const initRef = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        var _a;
        // open_price 为0或者不存在都无法获取到tradeInfo 提前拦截
        if (initRef.current || !open_price || new trade_utils_lib_1.SafeDecimal(open_price).equals(0)) {
            return;
        }
        const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
        initRef.current = true;
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
    }, [open_price]);
    // 用户输入防抖
    (0, react_1.useEffect)(() => {
        var _a;
        // open_price 为0或者不存在都无法获取到tradeInfo 提前拦截
        if (!open_price || new trade_utils_lib_1.SafeDecimal(open_price).equals(0)) {
            return;
        }
        const sub = (_a = debounceFn.current) === null || _a === void 0 ? void 0 : _a.call(debounceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // 以下参数改变时触发tradeInfo修改，debounce 用户输入
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [base, quote, top, bottom, row, grid_type, trend, leverage, user_investment, extra_margin, extra_margin_amount, is_copy_bot]);
    const throttleDepensOnPriceFn = (0, react_1.useRef)((0, lodash_1.throttle)(() => {
        const sub = getTradeInfoAPI(requestRef.current)
            .pipe((0, rxjs_1.catchError)((error) => {
            const newReq = Object.assign(Object.assign({}, requestRef.current), { quote_investment: "0" });
            return getTradeInfoAPI(newReq);
        }))
            .subscribe({
            next: (data) => {
                setTradeInfo(data);
            },
            error: (error) => {
                // console.log(`useFuturesTradeInfo: ${JSON.stringify(error)}`);
            },
        });
        return sub;
    }, 5000));
    // 当前价格变更节流
    (0, react_1.useEffect)(() => {
        var _a;
        // 只有在当前参数合理时，才去根据价格刷新数据
        if (!tradeInfo) {
            return;
        }
        // open_price 为0或者不存在都无法获取到tradeInfo 提前拦截
        if (!open_price || new trade_utils_lib_1.SafeDecimal(open_price).equals(0)) {
            return;
        }
        if (!Number(quote_investment) || // 没有投资额
            !Number(tradeInfo.min_investment) || // 没有最小投资额
            !Number(tradeInfo.max_investment) // 没有最大投资额
        ) {
            return;
        }
        const sub = (_a = throttleDepensOnPriceFn.current) === null || _a === void 0 ? void 0 : _a.call(throttleDepensOnPriceFn);
        return () => sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open_price, quote_investment]);
    const queryNewTradeInfo = (0, react_1.useCallback)(() => {
        return getTradeInfoAPI(request).pipe((0, rxjs_1.tap)((value) => {
            setTradeInfo(value);
        }));
    }, [request]);
    return { tradeInfo, queryNewTradeInfo, loading: loading };
};
exports.useGridV4FuturesTradeInfo = useTradeInfo;
exports.getGridV4FuturesTradeInfo = getTradeInfoAPI;
